module.exports = __webpack_public_path__ + "static/media/read.232aab28.svg";